import React, { Component } from 'react'
import styled from 'styled-components'
import { Container, Row, Col, media } from 'styled-bootstrap-grid'
import theme from 'ui/styles/theme'

const Wrapper = styled.div`
  margin : 145px auto 80px;
`

const CTAContainer = styled.div`
  border-top : 1px solid ${theme.colors.tones.darker};
  width      : 100%;
`

const CallToAction = styled.p`
  font-size      : 12px;
  font-weight    : 500;
  margin         : 30px auto 40px;
  text-transform : uppercase;

  ${media.xs`
    font-size : 10px;
    margin    : 15px auto 40px;
  `}
`

const Title = styled.h1`
  font-size   : 60px;
  font-weight : 300;
  line-height : 60px;
  margin-top  : 0;

  ${media.xs`
    font-size   : 35px;
    line-height : 38px;
  `}
`

const Description = styled.p`
  font-size   : 30px;
  font-weight : 300;
  line-height : 36px;
  margin-top  : 0;

  ${media.xs`
    font-size   : 18px;
    line-height : 23px;
  `}
`

export default class index extends Component {
  render() {
    const { cta, title, description } = this.props

    return (
      <Wrapper>
        <Container fluid>
          <Row>
            <Col xs={12}>
              <CTAContainer>
                <CallToAction>{cta}</CallToAction>
              </CTAContainer>
            </Col>
          </Row>
          <Row>
            <Col sm={5}>
              <Title>{title}</Title>
            </Col>
            <Col sm={6} smOffset={1}>
              <Description dangerouslySetInnerHTML={{ __html: description }}/>
            </Col>
          </Row>
        </Container>
      </Wrapper>
    )
  }
}



// WEBPACK FOOTER //
// ./src/ui/components/modules/HeaderText/index.js